module.exports = __webpack_public_path__ + "img/add_btn_icon110.a8b597ad.svg";